<template>
  
    <div class="mkt-preview">

        <h1>Docházkový list</h1>
    
        <div class="mx-8">
            <table class="mkt-user-detail">
                <tr>
                    <td>Jméno zaměstnance:</td>
                    <td class="mkt-user-cell"><strong>{{ user.name }}</strong></td>
                    <td rowspan="3">
                        <h2>E Zilly CZ, s.r.o.</h2>
                    </td>
                    <td rowspan="3">
                        <img src="../assets/img/ezilly-logo.png" alt="Ezilly">
                    </td>
                </tr>
                <tr>
                    <td>Období:</td>
                    <td class="mkt-user-cell capitalize">{{ getMonthName(marktime.month) }} / {{ marktime.year }}</td>
                </tr>
                <tr>
                    <td>Osobní číslo:</td>
                    <td class="mkt-user-cell">{{ user.number }}</td>
                </tr>
            </table>
        </div>

        <table class="mkt-preview-table">
            <tr>
                <th rowspan="3" class="mkt-rotate mkt-td-border-bottom">
                    <div>Nepřítomnost</div>
                </th>
                <th rowspan="2">Důvod</th>
                <th class="mkt-cell-width" v-for="(day, i) in marktime.marktime" :key="i">
                    {{ i + 1 }}
                </th>
            </tr>
            <tr>
                <td v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.type != '0'">{{ day.type }}</span>
                    <span v-else-if="day.type === 'D' && day.halfday"> 1/2</span>
                    <span v-else>&nbsp;</span>
                </td>
            </tr>
            <tr>
                <th class="mkt-td-border-bottom">Přestávka</th>
                <td class="mkt-td-border-bottom" v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.timeFrom"> {{ breakTime(day) }}</span>
                </td>
            </tr>
            <tr>
                <th rowspan="6" class="mkt-rotate">
                    <div>
                        Odpracováno
                    </div>
                </th>
                <th>Začátek výkonu práce</th>
                <td v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.timeFrom"> {{ showTime(day.timeFrom) }}</span>
                </td>
            </tr>
            <tr>
                <th>Konec výkonu práce</th>
                <td v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.timeTo"> {{ showTime(day.timeTo) }}</span>
                </td>
            </tr>
            <tr>
                <td></td>
                <td v-for="(day, i) in marktime.marktime" :key="i">&nbsp;</td>
            </tr>
            <tr>
                <th>Náhradní volno</th>
                <td v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.timeOff">{{ day.timeOff }}</span>
                </td>
            </tr>
            <tr>
                <th>Přesčas</th>
                <td v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.overtime">{{ day.overtime }}</span>
                </td>
            </tr>
            <tr>
                <th>Celkem</th>
                <td v-for="(day, i) in marktime.marktime" :key="i">
                    <span v-if="day.timeFrom || day.timeOff">{{ total(day) }}</span>
                </td>
            </tr>
        </table>

        <div class="mkt-overview-wrapper">
            <table class="mkt-overview-table">
                <tr>
                    <th colspan="2"></th>
                    <th colspan="2">Odpracováno</th>
                </tr>
                <tr>
                    <th colspan="2"></th>
                    <th>Počet dnů</th>
                    <th>Počet hodin</th>
                </tr>
                <tr>
                    <th colspan="2">Odpracovaná doba</th>
                    <td class="mkt-td-center mkt-td-size-big">{{ workingDays }}</td>
                    <td class="mkt-td-center mkt-td-size-big">{{ workingHours }}</td>
                </tr>
                <tr v-for="reason in reasons" :key="reason.id">
                    <th>{{ reason.id }}</th>
                    <td>- {{ reason.czName }}</td>
                    <td class="mkt-td-center mkt-td-size-big">{{ getReasonDays(reason.id) }}</td>
                    <td class="mkt-td-center mkt-td-size-big">{{ getReasonHours(reason.id) }}</td>
                </tr>
                <tr>
                    <th>Přesčas</th>
                    <td></td>
                    <td></td>
                    <td class="mkt-td-center mkt-td-size-big">{{ overtimeHours }}</td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td colspan="2">Celkem</td>
                    <th class="mkt-td-center mkt-td-size-big">{{ totalDays }}</th>
                    <th class="mkt-td-center mkt-td-size-big">{{ totalHours }}</th>
                </tr>
            </table>

            <div class="mkt-vouchers-wrapper">
                <div>
                    <table class="mkt-overview-vouchers">
                        <tr>
                            <td>Stravenkový paušal</td>
                        </tr>
                        <tr>
                            <th>{{ vouchers }}</th>
                        </tr>
                    </table>
                </div>

                <div class="mkt-signature">
                    <table>
                        <tr v-if="marktime.publishedDate">
                            <td class="text-center italic">
                                <div>{{ user.name }}</div>
                                <div class="text-sm">{{ formatDate(marktime.publishedDate) }}</div>
                            </td>
                            <td class="text-center italic">
                                <div v-if="approvalUser">
                                    <div>{{ approvalUser.name }}</div>
                                    <div class="text-sm">{{ formatDate(marktime.approvedDate) }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>-----------------------------------</td>
                            <td>-----------------------------------</td>
                        </tr>
                        <tr>
                            <td class="mkt-td-center">Podpis zaměstnance</td>
                            <td class="mkt-td-center">Podpis zaměstnavatele</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import moment from 'moment'
import mixinMarktime from '../mixins/marktime'
import helpers from '../helpers'

export default {

    mixins: [
        mixinMarktime
    ],

    computed: {
        currentUser() {
            return this.user
        }
    },
    
    props: [
        'user',
        'approvalUser'
    ],

    methods: {
        breakTime(day) {
            var timeTo = moment(day.timeTo)
            var timeFrom = moment(day.timeFrom)
            var dur = moment.duration(timeTo.diff(timeFrom)).asHours()
            if (dur > 4) return '0,5'
        },

        showTime(day) {
            var date = new Date(day)
            return moment(date).format('HH:mm')
        },

        total(day) {
            return helpers.getDuration(day) + (day.timeOff || 0)
        },

        getMonthName(month) {
            return moment({
                month: month
            }).format('MMMM')
        },

        formatDate(data) {
            return moment(data.seconds * 1000).format('DD.MM.YYYY')
        },
    }

}
</script>

<style lang="scss" scoped>
    * { 
        font-family: 'Arial', 'Helvetica', sans-serif;
    } 
    h1 {
        text-align: center;
        font-weight: normal;
    }
    h2 {
        padding:0 5rem;
        text-align: center;
        font-size: 22px;
    }
    .mkt-preview {
        margin: 2rem 0 0 0;
    }
    .mkt-cell-width {
        width: 2.8%;
    }
    .mkt-user-detail {
        margin: 0.5rem 0 1.5rem 0;
        width: 100%;
        font-size: 12px;

        .mkt-user-cell {
            border-bottom: 1px solid black;
            text-align: center;
            padding: 0 3rem;
        }
    }
    .mkt-preview-table {
        border-spacing: 0;
        width: calc(100% - 4rem);
        margin: 0 2rem;
        border: 2px solid black;

        th,td {
            border-left: 1px solid #aaa;
            border-bottom: 1px solid #aaa;
            white-space: nowrap;
            text-align: center;
            font-size: 10px;
            padding: 0.2rem 0;
        }
        tr:last-child td {
            border-bottom: 0;
        }
    }
    .mkt-overview-table {
        border-spacing: 0;
        margin: 1rem 2rem 0 2rem;
        border: 2px solid black;

        th, td {
            border-left: 1px solid #aaa;
            border-bottom: 1px solid #aaa;
            white-space: nowrap;
            padding: 0 .3rem;
            font-size: 12px;
        }
        tr:last-child td {
            border-bottom: 0;
        }
    }
    .mkt-td-center {
        text-align: center;
    }
    .mkt-vouchers-wrapper {
        display: flex;
        flex-direction: column;
        margin-left: 1rem;
    }
    .mkt-signature {
        flex: 1;
        display: flex;
        align-items: flex-end;

        td {
            padding-right: 4rem;
        }
    }
    .mkt-overview-vouchers {
        border-spacing: 0;
        margin-top: 4rem;
        border: 2px solid black;

        th, td {
            border: 1px solid #aaa;
            white-space: nowrap;
            font-size: 16px;
            padding: .5rem;
            text-align: center;
        }
    }
    .mkt-overview-wrapper {
        display: flex;
    }
    .mkt-rotate {
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        width: 20px;

        div {
            margin-left: -30px;
            margin-right: -30px; 
            transform: rotate(-90deg);
        }
    }
    .mkt-td-size-big {
        font-size: 14px !important;
    }
    .mkt-td-border-bottom {
        border-bottom: 2px solid black !important;
    }
    img {
        max-width: 110px;
    }
    @media print{
        @page {
            size: landscape
        }
    }
</style>